<template>
  <div>
    <a-modal v-model:visible="visible" title="修改主菜单" @ok="handleOk" okText="修改" cancelText="取消" :afterClose="closeModal" width="30vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <a-form-item label="主菜单名称">
          <a-input v-model:value="data.name" />
        </a-form-item>

      </a-form>

    </a-modal>
  </div>
</template>

<script>
import { reactive } from "vue";
import { Update } from "/src/api/menu.js";
export default {
  components: {

  },
  data() {
    return {
      visible: this.modelValue,

      medicine: "",
      data: {
        name: undefined,
        description: undefined,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue', 'ok'],
  created() {

  },
  mounted() {
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: {}
    },
  },
  computed: {

  },
  methods: {

    async handleOk() {
      let _this = this;

      // 去除名称中的空格与回车
      const name = this.data.name ? String(this.data.name).replace(/\s+/g, ' ').trim() : this.data.name;
      let res = await Update({ id: this.record.parentId, name: name })
      if (res.errCode == 0) {
        _this.$message.success("修改成功", function () { });
        _this.visible = false
        this.data = {
          name: undefined,
          description: undefined,
        }
        this.$emit('ok')
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    }
    //初始化data所有数据，并关闭modal
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
